require('./hireCardOpenDebitStep1.scss');
// @ vendors
const PropTypes = require('prop-types');
const React = require('react');

// @ helpers
const { FormattedText, formatText } = require('core/i18n').i18n;
const PersonalDataHelper = require('utilities/personalDataHelper');

// @ components
const { HireInformation } = require('components/hire/hireInformation/hireInformation');
const HiringProductInformation = require('components/hiringProductInformation/hiringProductInformation');
const { OKCheckbox } = require('commonsComponents/OKCheckbox');
const PreContractualMailInfo = require('components/contactCenter/preContractualMailInfo/preContractualMailInfo');
const ContactCenterRender = require('components/conditionalRender/contactCenterRender')

// @ constants
const { FIRST_STEP } = require('constants/index');
const { OPEN_DEBIT_CARD_PRODUCT_ALIAS,
    OPEN_DEBIT_CARD_PRODUCT_MIN_ALIAS,
    PRODUCT_HIRING_COMPONENT_ID } = require('constants/hiringProductInformation');
const { GC } = require('constants/flagBasedFeatures');


class hireCardOpenDebitStep1 extends React.Component {

    constructor(props){
        super(props);
        this.state = {
            openDebitWrapUp: false,
        };
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        const {
            hireInformationOpenDebitError,
            hireInformationOpenDebitSuccess,
            immHireInformation,
        } = nextProps;
        let stateUpdates = null;
        let openDebitWrapUp = false;

        if (__CONTACT_CENTER__ && !prevState.openDebitWrapUp) {
            if (immHireInformation.get('fetchSuccess')) {
                openDebitWrapUp = true;
                hireInformationOpenDebitSuccess();
            } else if (immHireInformation.get('error')) {
                openDebitWrapUp = true;
                hireInformationOpenDebitError();
            }
        }

        if (openDebitWrapUp) {
            stateUpdates = {
                openDebitWrapUp,
            };
        }

        return stateUpdates;
    }

    componentDidMount() {
        const { setTermsAndCondsText } = this.props;

        if (!__CONTACT_CENTER__) {
            const { requestPDFMerge, contracts } = this.props;
            const pdfurls = contracts && contracts.get ? contracts.get('prestacion_servicios_fisicas', '') : '';
            const product = {
                id: OPEN_DEBIT_CARD_PRODUCT_MIN_ALIAS
            };
            requestPDFMerge([{ 'url': pdfurls }], [product]);
        } else if (!!setTermsAndCondsText) {
            //This action is also called in the last step of the current hiring, if you update one remeber that maybe you should update the other one
            setTermsAndCondsText('hireCardOpenDebit-step3CheckboxText');
        }
    }

    buildLegalConfirmationSection() {
        if (!__CONTACT_CENTER__) return null;

        const { immHireInformation, immHiringProductInformation, gestorCrossEnabled } = this.props
        const information = gestorCrossEnabled ? immHiringProductInformation.get('cmsResponse') : immHireInformation.get('information');
        if (!information) return null

        const {
            contractName,
            handleAgreementCheckboxChange,
            immHireCardOpenDebit,
            immPreContractualMail,
            immProfileFields,
            requestProfile,
            sendMailParams,
            sendPreContractualMail
        } = this.props;

        const clientEmail = PersonalDataHelper.getEmail(immProfileFields);
        const profileError = immProfileFields.get('error');
        const hasBeenEmailSent = immPreContractualMail.get('mailSent');
        const immStep = immHireCardOpenDebit.getIn(['steps', FIRST_STEP]);
        const agreementLabel = <FormattedText value="hireCardOpenDebit-step3CheckboxText" />; // Re-uses step 3 labels because they have to be the same
        const agreementChecked = immStep.get('agreementChecked');
        const agreementErrorVisible = immStep.get('agreementIsDirty') && !immStep.get('agreementChecked');
        const agreementErrorMsg = formatText('hireCardOpenDebit-step3CheckboxErrorMsg'); // Re-uses step 3 labels because they have to be the same
        const newSendMailParams = { ...sendMailParams, product: OPEN_DEBIT_CARD_PRODUCT_MIN_ALIAS }

        return (
            <section className="hire-card-open-debit-step-one__legal-confirmation-section">
                <PreContractualMailInfo
                    contractName={contractName}
                    email={clientEmail}
                    preContractualMail={immPreContractualMail}
                    profileError={profileError}
                    requestProfile={requestProfile}
                    sendEmail={sendPreContractualMail}
                    sendMailParams={newSendMailParams}
                />
                <div className="hire-card-open-debit-step-one__checkbox-container">
                    <OKCheckbox
                        idName="hireCardOpenDebitAgreementCheckbox"
                        disabled={!hasBeenEmailSent}
                        errorState={agreementErrorVisible}
                        errorMessage={agreementErrorMsg}
                        label={agreementLabel}
                        onChange={handleAgreementCheckboxChange}
                        value={agreementChecked}
                    />
                </div>
            </section>
        );
    }

    render() {
        const { immHireInformation, gestorCrossEnabled,  flagBasedFeatures } = this.props;
        const legalConfirmationSection = this.buildLegalConfirmationSection();
        let productInformationComponent;
        if (gestorCrossEnabled && flagBasedFeatures && flagBasedFeatures.get(GC)) {
            productInformationComponent = (
                <React.Fragment>
                    <HiringProductInformation
                        productAlias={OPEN_DEBIT_CARD_PRODUCT_ALIAS}
                        productComponentId={PRODUCT_HIRING_COMPONENT_ID}
                    />
                    <ContactCenterRender>
                        {legalConfirmationSection}
                    </ContactCenterRender>
                </React.Fragment>
            )
        }
        else {
            productInformationComponent = (
                <article className="hire-card-open-debit__step-one">
                    <FormattedText
                        className="hire-card-open-debit__step-title"
                        value="hireCardOpenDebit-step1Title"
                    />
                    <HireInformation
                        hireCmsKey={__CONTACT_CENTER__ ? "opendebit_cc" : "opendebit"}
                        immHireInformation={immHireInformation}
                    />
                    <ContactCenterRender>
                        {legalConfirmationSection}
                    </ContactCenterRender>
                </article>
            )
        }
        return (
            <div>
                {productInformationComponent}
            </div>
        );
    }
}

hireCardOpenDebitStep1.propTypes = {
    contractName: PropTypes.string,
    contracts: PropTypes.object.isRequired,
    flagBasedFeatures: PropTypes.object.isRequired,
    gestorCrossEnabled: PropTypes.bool,
    handleAgreementCheckboxChange: PropTypes.func,
    hireCmsKey: PropTypes.string.isRequired,
    hireInformationOpenDebitError: PropTypes.func,
    hireInformationOpenDebitSuccess: PropTypes.func,
    immHireCardOpenDebit: PropTypes.object,
    immHireInformation: PropTypes.object.isRequired,
    immHiringProductInformation: PropTypes.object.isRequired,
    immPreContractualMail: PropTypes.object,
    immProfileFields: PropTypes.object,
    requestPDFMerge: PropTypes.func.isRequired,
    requestProfile: PropTypes.func,
    sendMailParams: PropTypes.object,
    sendPreContractualMail: PropTypes.func,
    setTermsAndCondsText: PropTypes.func,
};

module.exports = hireCardOpenDebitStep1;
